import {

  GET_USER_DEFINITIONS_SUCCESS,
  ADD_USER_DEFINITION_SUCCESS,
  UPDATE_USER_DEFINITION_SUCCESS,
  DELETE_USER_DEFINITION_SUCCESS,
  USER_DEFINITION_API_ERROR,
  CREATE_NEW_USER_DEFINITION_SUCCESS,
  CONFIRM_NEW_USER_DEFINITION_SUCCESS,
  INSERT_USER_KEYS,
  INSERT_USER_KEYS_SUCCESS,
  GET_USER_BY_USERNAME_SUCCESS,
  GET_USERENCKEY_BY_MERCHANTGUID_SUCCESS,
  GET_APIKEY_BY_MERCHANTID_SUCCESS,
  GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID,
  GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID_SUCCESS,
  GET_USER_BY_USERNAME_SYNC,
  GET_USER_BY_USERNAME_SYNC_SUCCESS,
  GET_USER_DEFINITIONS_BY_USERNAME,
  GET_USER_DEFINITIONS_BY_USERNAME_SUCCESS

} from "./actionTypes"

const INIT_STATE = {
  userDefinitions: [],
  error: {},
  user: {},
  recordListUser: [],
  recordListInsertKey: [],
  recordListUserEncKey: [],
  recordListByMerchantId: []
}

const UserDefinition = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USER_DEFINITIONS_SUCCESS:
      return {
        ...state,
        userDefinitions: action.payload,
      }
      case GET_USER_DEFINITIONS_BY_USERNAME_SUCCESS:
        return {
          ...state,
          userDefinitions: action.payload,
        }
    case ADD_USER_DEFINITION_SUCCESS:
      return {
        ...state,
        userDefinitions: [...state.userDefinitions, action.payload],
      }

    case UPDATE_USER_DEFINITION_SUCCESS:
      return {
        ...state,
        userDefinitions: state.userDefinitions.map(userDefinition =>
          userDefinition.guid.toString() === action.payload.guid.toString()
            ? { userDefinition, ...action.payload }
            : userDefinition
        ),
      }

    case DELETE_USER_DEFINITION_SUCCESS:
      return {
        ...state,
        userDefinitions: state.userDefinitions.filter(
          userDefinition => userDefinition.guid.toString() != action.payload.toString()
        ),
      }

    case CREATE_NEW_USER_DEFINITION_SUCCESS:
      return {
        ...state,
        user: action.payload
      }

    case CONFIRM_NEW_USER_DEFINITION_SUCCESS:
      return {
        ...state,
        userDefinitions: [...state.userDefinitions, action.payload]
      }

    case INSERT_USER_KEYS:
      return {
        ...state, 
        recordListInsertKey: action.payload,
        loading: true
      }

    case INSERT_USER_KEYS_SUCCESS:
      return {
        ...state, 
        recordListInsertKey: action.payload,
        loading: false
      }

    case GET_USER_BY_USERNAME_SUCCESS:
      return {
        ...state,
        recordListUser: action.payload,
      }

    case GET_USER_BY_USERNAME_SYNC:
      return {
        ...state,
        recordListUser: action.payload,
        loadingUserName: true
      }

    case GET_USER_BY_USERNAME_SYNC_SUCCESS:
      return {
        ...state,
        recordListUser: action.payload,
        loadingUserName: false
      }

    case GET_USERENCKEY_BY_MERCHANTGUID_SUCCESS:
      return {
        ...state,
        recordListUserEncKey: action.payload,
      }

    case GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID:
      return {
        ...state,
        recordListUserEncKey: action.payload,
        loadingGetUserKey: true
      }

    case GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID_SUCCESS:
      return {
        ...state,
        recordListUserEncKey: action.payload,
        loadingGetUserKey: false
      }

    case GET_APIKEY_BY_MERCHANTID_SUCCESS:
      return {
        ...state,
        recordListByMerchantId: action.payload,
      }

    case USER_DEFINITION_API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    default:
      return state

  }
}

export default UserDefinition